import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Typography } from '@one-thd/sui-atomic-components';
import { Checkmark } from '@one-thd/sui-icons';

export const AfterSubmitMessage = ({
  color,
  icon: Icon,
  message,
  thanksMessageHideTime,
}) => {
  const [hideComponent, setHideComponent] = useState(false);

  useEffect(() => {
    if (thanksMessageHideTime) {
      setTimeout(() => {
        setHideComponent(true);
      }, thanksMessageHideTime);
    }
  }, []);

  if (hideComponent) return null;

  const iconClasses = classnames(
    'sui-flex sui-justify-center sui-items-center sui-rounded-full sui-shrink-0 sui-w-6 sui-h-6 sui-mr-2',
    {
      'sui-bg-success': color === 'success',
      'sui-bg-danger': color === 'danger',
      'sui-bg-warning': color === 'warning',
      'sui-bg-info': color === 'info',
    },
  );

  return (
    <div className="sui-flex sui-items-center">
      {/* eslint-disable-next-line max-len */}
      <div className={iconClasses}>
        <Icon color="inverse" size="small" />
      </div>
      <Typography variant="body-sm" height="tight" color={color}>{message}</Typography>
    </div>
  );
};

AfterSubmitMessage.displayName = 'AfterSubmitMessage';

AfterSubmitMessage.propTypes = {
  color: PropTypes.oneOf(['success', 'danger', 'warning', 'info']),
  icon: PropTypes.shape({
    $$typeof: PropTypes.symbol,
    render: PropTypes.func,
  }),
  message: PropTypes.string,
  thanksMessageHideTime: PropTypes.number,
};

AfterSubmitMessage.defaultProps = {
  color: 'success',
  icon: Checkmark,
  message: 'Thank you. Your feedback helps us improve your online shopping experience.',
  thanksMessageHideTime: null,
};
